module.exports = __webpack_public_path__ + "img/aesthetic.65140330.jpg";